<template>
    <v-layout>
        <preferred-communication-error
            :visible="preferredCommunicationError"
            @closeDialog="closeDialog"
        />
        <metadata-custom-dropdown
            :metadata="metadata"
            :required="required"
            :value="value"
            @update:value="emitValue"
        />
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { assign, find, map } from 'lodash';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import PreferredCommunicationError from '@/components/metadata/dialogs/PreferredCommunicationError';
import { MetadataEnum } from '@/enums';
import MetadataCustomDropdown from '@/components/metadata/inputs/dropdown/MetadataCustomDropdown.vue';

export default {
    name: 'covid-screening-preferred-communication',
    components: { PreferredCommunicationError, MetadataCustomDropdown },
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        otherMetadata: { type: Array, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            preferredCommunicationError: false,
        };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        appendIcon() {
            return this.withIcon ? '' : '';
        },
        preferredCommunicationEmailOption() {
            return this.$i18n.t('covidScreeningMetadataLang.covidScreeningPreferredCommunication.dropDown')[0];
        },
        preferredCommunicationPhoneOption() {
            return this.$i18n.t('covidScreeningMetadataLang.covidScreeningPreferredCommunication.dropDown')[1];
        },
        consentReceiveResultByEmailSmsMetadata() {
            return this.otherMetadata && find(this.otherMetadata, ['metadata', MetadataEnum.COVID_SCREENING_CONSENT_RECEIVE_RESULT_BY_EMAIL_SMS]);
        },
        consentReceiveResultByEmailSmsMetadataValue() {
            return this.consentReceiveResultByEmailSmsMetadata ? this.consentReceiveResultByEmailSmsMetadata.value : false;
        },
        emailMetadata() {
            return this.otherMetadata && find(this.otherMetadata, ['metadata', MetadataEnum.EMAIL]);
        },
        emailMetadataValue() {
            return this.emailMetadata ? this.emailMetadata.value : false;
        },
        dropDownOptions() {
            const options = this.$i18n.t('covidScreeningMetadataLang.covidScreeningPreferredCommunication.dropDown');
            return map(options, (option, key) => {
                return assign({},
                    { key: key },
                    { text: option },
                    { value: option }
                );
            });
        },
        validatePreferredCommunication() {
            if (this.value === this.preferredCommunicationPhoneOption && this.consentReceiveResultByEmailSmsMetadataValue) {
                return this.$i18n.t('errors.screening.preferredCommunicationEmail.error');
            }
            else if (!this.value) {
                return this.$i18n.t('base.errors.requiredField');
            }
            return true;
        },
    },
    methods: {
        emitValue(value) {
            this.preferredCommunicationError = false;
            if (this.consentReceiveResultByEmailSmsMetadataValue && value) {
                if (this.emailMetadataValue && value !== this.preferredCommunicationEmailOption) {
                    this.preferredCommunicationError = true;
                }
                else if (!this.emailMetadataValue && value === this.preferredCommunicationEmailOption) {
                    this.preferredCommunicationError = true;
                }
                else if (value === this.preferredCommunicationPhoneOption) {
                    this.preferredCommunicationError = true;
                }
            }
            this.$emit('update:value', value);
        },

        closeDialog() {
            this.preferredCommunicationError = false;
        },
    },
};
</script>

<style scoped>
.border::v-deep {
    border: 2px solid var(--v-border-metadata-color)!important;
    border-radius: 4px!important;
}
</style>
